import { booleanAttribute } from "#ce/utils/props";

export const INTERACTION_MODES = Object.freeze({
  expand: "expand",
  modal: "modal",
});

export function isInteractionMode(value) {
  return Object.values(INTERACTION_MODES).includes(value);
}

export const props = Object.freeze({
  /**
   * Heading shown in the card header. Overridden when the title slot is provided.
   *
   * @type {String}
   * @default undefined
   */
  title: {
    type: String,
    default: undefined,
  },
  /**
   * Optional secondary line rendered below the title.
   *
   * @type {String}
   * @default undefined
   */
  subtitle: {
    type: String,
    default: undefined,
  },
  /**
   * How the activator behaves when the card is clicked or focused with Enter/Space. "expand"
   * toggles the inline expanded body (the default standalone use); "modal" leaves the body
   * collapsed and opens an sp-modal containing the same content — used when the card lives inside
   * sp-interactive-grid-group.
   *
   * @type {String}
   * @storybook-control select
   * @values expand, modal
   * @default "expand"
   */
  interactionMode: {
    type: String,
    default: INTERACTION_MODES.expand,
    validator: isInteractionMode,
  },
  /**
   * Initial expanded state when interaction-mode is expand. Also expanded automatically when the
   * URL hash matches the host id, so deep-links can land on a specific open card.
   *
   * @type {Boolean|String}
   * @default false
   */
  expanded: booleanAttribute(),
});
